import { baseApi } from "../baseApi";

const MUNICIPALITY_BASE_URL = "/municipality";

export const municipalityApi = baseApi.injectEndpoints({
  tagTypes: ["Municipality"],

  endpoints: (builder) => ({
    createMunicipality: builder.mutation({
      query: (payload) => ({
        url: `${MUNICIPALITY_BASE_URL}`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: (result, error, { _id }) => [
        { type: "Municipality", id: "LIST" },
      ],
    }),

    getMunicipalityList: builder.query({
      query: (params) => ({
        url: `${MUNICIPALITY_BASE_URL}`,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result?.data?.map(({ _id }) => ({
                type: "Municipality",
                _id,
              })),
              { type: "Municipality", id: "LIST" },
            ]
          : [{ type: "Municipality", id: "LIST" }],
    }),

    getMunicipalityByDistrictId: builder.query({
      query: (districtId) => ({
        url: `${MUNICIPALITY_BASE_URL}/district/${districtId}`,
        method: "GET",
      }),
      providesTags: (result, error, districtId) => [
        { type: "Municipality", id: `District-${districtId}` },
        { type: "Municipality", id: "LIST" },
      ],
    }),

    getMultipleMunicipalityByMultipleDistrictId: builder.query({
      query: (params) => ({
        url: `${MUNICIPALITY_BASE_URL}/district`,
        method: "GET",
        params,
      }),
      providesTags: (result, error, districtId) => [
        { type: "Municipality", id: "LIST" },
      ],
    }),

    getMunicipalityDetail: builder.query({
      query: (id) => `${MUNICIPALITY_BASE_URL}/${id}`,
      providesTags: (result, error, id) => [
        { type: "Municipality", id },
        { type: "Municipality", id: "LIST" },
      ],
    }),

    updateMunicipality: builder.mutation({
      query: (payload) => {
        const { id, ...body } = payload;

        return {
          url: `${MUNICIPALITY_BASE_URL}/${id}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: (result, error, { _id }) => [
        { type: "Municipality", _id },
        { type: "Municipality", id: "LIST" },
      ],
    }),

    updateMunicipalityStatus: builder.mutation({
      query: ({ id, status }) => {
        return {
          url: `${MUNICIPALITY_BASE_URL}/${id}/status`,
          method: "PUT",
          body: { status },
        };
      },
      invalidatesTags: (result, error, { id }) => [
        { type: "Municipality", id },
        { type: "Municipality", id: "LIST" },
      ],
    }),

    getDdlMunicipalityList: builder.query({
      query: (params) => ({ url: `${MUNICIPALITY_BASE_URL}/ddl`, params }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result?.data?.map(({ _id }) => ({
                type: "Municipality",
                _id,
              })),
              { type: "Municipality", id: "LIST" },
            ]
          : [{ type: "Municipality", id: "LIST" }],
    }),
  }),
});

export const {
  useCreateMunicipalityMutation,
  useGetMunicipalityListQuery,
  useLazyGetMunicipalityListQuery,
  useGetMunicipalityDetailQuery,
  useGetMultipleMunicipalityByMultipleDistrictIdQuery,
  useLazyGetMultipleMunicipalityByMultipleDistrictIdQuery,
  
  useGetMunicipalityByDistrictIdQuery,
  useLazyGetMunicipalityByDistrictIdQuery,
  useUpdateMunicipalityMutation,
  useUpdateMunicipalityStatusMutation,

  useGetDdlMunicipalityListQuery,
  useLazyGetDdlMunicipalityListQuery,
} = municipalityApi;
